export default "__VITE_ASSET__BUfXDhQS__"